module.exports = __webpack_public_path__ + "assets/img/13_987.cb350620.jpg";